import { Grid } from "@mui/system";
import { type ComponentProps, type FC } from "react";

import { ArticleCard } from "~/feature/insights/components/ArticleCard";
import { type IInsight } from "~/feature/insights/types";

interface IArticleCardGridProps {
  insights: IInsight[];
  variant?: ComponentProps<typeof ArticleCard>["variant"];
  showImage?: boolean;
  showTags?: boolean;
}

export const ArticleCardGrid: FC<IArticleCardGridProps> = ({
  insights,
  variant,
  showImage,
  showTags,
}) => (
  <Grid container spacing={2} sx={{ width: "100%" }}>
    {insights.map((insight) => (
      <Grid key={insight._id} size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
        <ArticleCard
          insight={insight}
          variant={variant}
          showImage={showImage}
          showTags={showTags}
        />
      </Grid>
    ))}
  </Grid>
);
